// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__37oO1","auto":"styles_auto__35_Ct","small":"styles_small__jfPLC","medium":"styles_medium__1bZlE","large":"styles_large__2LJm-"};